import React from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  Title,
  useListContext,
} from 'react-admin';

import { Card, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  rootCard: { borderRadius: 12 },
}));

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const ListPageComum = ({
  title,
  filters,
  perPage = 50,
  sort,
  filter,
  filterDefaultValues,
  toolbarActions = null,
  renderGrid,
  listProps = {},
  ...rest
}) => {
  const classes = useStyles();

  return (
    <ListBase
      perPage={perPage}
      sort={sort}
      filter={filter}
      filterDefaultValues={filterDefaultValues}
      {...listProps}
    >
      <InnerList
        title={title}
        filters={filters}
        toolbarActions={toolbarActions}
        renderGrid={renderGrid}
        classes={classes}
        {...rest}
      />
    </ListBase>
  );
};

const InnerList = ({
  title,
  filters,
  toolbarActions,
  renderGrid,
  classes,
  ...props
}) => {
  const listContext = useListContext();

  return (
    <>
      <Title title={title} />
      <ListToolbar
        filters={props.filters || filters}
        actions={toolbarActions}
        {...props}
      />
      <Card className={classes.rootCard}>
        <Divider />
        <div>{renderGrid({ listProps: props, classes, listContext })}</div>
        <TransacoesPagination />
      </Card>
    </>
  );
};

export default ListPageComum;
